(() => {
  const initialiseHeader = (header) => {
    if (header.dataset.editorialReady) return;
    header.dataset.editorialReady = 'true';
    const menu = header.querySelector('[data-mobile-menu]');
    const hours = header.querySelector('[data-editorial-hours]');
    const hiddenByMenu = new Map();
    const updateBackground = () => {
      if (menu && !menu.hidden) {
        const branches = [...document.body.children].filter((element) => !element.contains(header));
        const headerBranches = [...header.children].filter((element) => element !== menu);
        const headerGroup = header.parentElement;
        if (headerGroup) branches.push(...[...headerGroup.children].filter((element) => element !== header && !element.contains(header)));
        [...branches, ...headerBranches].forEach((element) => {
          if (!hiddenByMenu.has(element)) hiddenByMenu.set(element, element.inert);
          element.inert = true;
        });
      } else {
        const wasModal = hiddenByMenu.size > 0;
        hiddenByMenu.forEach((wasInert, element) => { element.inert = wasInert; });
        hiddenByMenu.clear();
        if (wasModal && (document.activeElement === document.body || menu?.contains(document.activeElement))) {
          header.querySelector('[data-menu-toggle]')?.focus();
        }
      }
    };
    if (menu) new MutationObserver(updateBackground).observe(menu, { attributes: true, attributeFilter: ['hidden'] });
    header.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || !menu || menu.hidden) return;
      const link = event.target.closest('[data-plan-finder-jump]');
      const finder = document.getElementById('plans');
      if (!link || !menu.contains(link) || !finder) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      menu.querySelector('button[data-menu-close]')?.click();
      requestAnimationFrame(() => {
        finder.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        finder.focus({ preventScroll: true });
      });
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const focusedDetails = document.activeElement?.closest('.editorial-header details[open]');
      if (focusedDetails && (!menu || menu.hidden)) {
        focusedDetails.removeAttribute('open');
        focusedDetails.querySelector('summary')?.focus();
      }
      if (hours?.open) hours.removeAttribute('open');
    }, true);
    document.addEventListener('click', (event) => {
      if (hours?.open && !hours.contains(event.target)) hours.removeAttribute('open');
    });
    window.matchMedia('(min-width: 1151px)').addEventListener('change', (event) => {
      if (event.matches && menu && !menu.hidden) menu.querySelector('button[data-menu-close]')?.click();
    });
  };
  const initialiseFooter = (footer) => {
    if (footer.dataset.editorialReady) return;
    footer.dataset.editorialReady = 'true';
    const desktop = window.matchMedia('(min-width: 761px)');
    const sync = () => footer.querySelectorAll('[data-editorial-footer-group]').forEach((group) => { group.open = desktop.matches; });
    sync();
    desktop.addEventListener('change', sync);
    footer.querySelectorAll('[data-editorial-footer-group]').forEach((group) => {
      group.querySelector(':scope > summary')?.addEventListener('click', (event) => {
        if (desktop.matches) event.preventDefault();
      });
    });
  };
  const initialise = (scope = document) => {
    if (scope.matches?.('.editorial-header')) initialiseHeader(scope);
    scope.querySelectorAll?.('.editorial-header').forEach(initialiseHeader);
    if (scope.matches?.('[data-editorial-footer]')) initialiseFooter(scope);
    scope.querySelectorAll?.('[data-editorial-footer]').forEach(initialiseFooter);
  };
  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
